import { httpClient } from '../httpClient';
import {
  IEpisodeOutline,
  CreateEpisodeOutlineRequest,
  UpdateEpisodeOutlineRequest
} from '@packages/global';

/**
 * 分集大纲 API 模块
 * 处理分集大纲的 CRUD 操作
 */
export class EpisodeOutlineApi {

  /**
   * 获取分集大纲列表
   */
  async list(projectId: string): Promise<IEpisodeOutline[]> {
    return httpClient.get<IEpisodeOutline[]>(`/user/episode-outlines?projectId=${projectId}`);
  }

  /**
   * 创建分集大纲
   */
  async create(data: CreateEpisodeOutlineRequest): Promise<IEpisodeOutline> {
    return httpClient.post<IEpisodeOutline>('/user/episode-outlines', data);
  }

  /**
   * 更新分集大纲
   */
  async update(id: string, data: UpdateEpisodeOutlineRequest): Promise<IEpisodeOutline> {
    return httpClient.put<IEpisodeOutline>(`/user/episode-outlines/${id}`, data);
  }

  /**
   * 删除分集大纲
   */
  async delete(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/episode-outlines/${id}`);
  }
}

// 导出单例实例
export const episodeOutlineApi = new EpisodeOutlineApi();
